import {
  Box,
  ColumnLayout,
  Container,
  SpaceBetween,
  Header,
  Grid,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useContext } from "react";
import { GlobalContext } from "../context";
import { useMediaQuery } from 'react-responsive';
import * as awsui from "@cloudscape-design/design-tokens";
import { useLocation, useNavigate } from "react-router-dom";
import { navigateFn } from "../routingHelper";
import { CustomButton, PrimaryButton, WarningButton } from "./buttons";

export default function CurrentSeries() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const { 
    theme, setTheme, 
  } = useContext(GlobalContext);
  const isSmallDevice = useMediaQuery({query: "only screen and (max-width : 768px)"});
  const isMediumDevice = useMediaQuery({query: "only screen and (min-width : 769px) and (max-width : 992px)"});
  const isLargeDevice = useMediaQuery({query: "only screen and (min-width : 993px) and (max-width : 1200px)"});
  const isDesktop = useMediaQuery({query: "only screen and (min-width : 1201px)"});


  return (
    <>
      <SpaceBetween size="xl">
        <center>
          <Box variant="h1" fontSize="heading-xl">
            Current Race Series
          </Box>
        </center>
        <Box textAlign="center">
          <Grid
            gridDefinition={[
              { colspan: { default: 12, xs: 6, m: 6 } },
              { colspan: { default: 12, xs: 6, m: 6 } },
              { colspan: { default: 12, xs: 6, m: 6 } },
              { colspan: { default: 12, xs: 6, m: 6 } },
              // { colspan: { default: 12, xs: 6, m: 6 } },
              // { colspan: { default: 12, xs: 6, m: 6 } },
            ]}
          >  
            {/* <Box padding={"xxl"} >
              <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                maxWidth: "500px",
              }}>
                <SpaceBetween size="xxl">
                  <Box>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "120px", minWidth: "200px" }}>
                      <center>
                        <img
                          src={theme === Mode.Light ? "/images/f3a-logo-small-dark.png" : "/images/f3a-logo-small-light.png"}
                          alt="F3A"
                          width="100%"
                        />
                      </center>
                    </div>
                  </Box>
                  <Box>
                    As a development series for up and coming drivers in Europe, the United States, Asia and Australia Formula 3 has seen many a high profile driver use it as a stepping stone to the top ranks of open wheel racing in Formula One and IndyCar. In the real world the Formula 3 has changed, but this specification of cars are still used in international racing right around the world in Formula Regional.
                  </Box>
                  <PrimaryButton 
                    url="/f3a-series" 
                    buttonName="F3A Series Info"
                  />
                </SpaceBetween>
              </div>
            </Box> */}
            <Box padding={"xxl"} >
              <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                maxWidth: "500px",
              }}>
                <SpaceBetween size="xxl">
                  <Box>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "120px", minWidth: "200px" }}>
                      <center>
                        <img
                          src={theme === Mode.Light ? "/images/f4a-logo-small-dark.png" : "/images/f4a-logo-small-light.png"}
                          alt="F4A"
                          width="100%"
                        />
                      </center>
                    </div>
                  </Box>
                  <Box>
                  At the end of another successful season of F3A late in 2022, Motorsport Australia approached us in regard to officially sanctioned E-Sports events in 2023. As the world’s leading junior formula, F4 was the obvious choice for FRG’s initial foray. This series will run from May through till December, with races scheduled for Tuesday nights on some of Australia and the world's greatest circuits.
                  </Box>
                  <PrimaryButton 
                      url="/f4a-series" 
                      buttonName="F4A Series Info" 
                    />
                </SpaceBetween>
              </div>
            </Box>
            <Box padding={"xxl"} >
              <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                maxWidth: "500px",
              }}>
                <SpaceBetween size="xxl">
                  <Box>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "120px", minWidth: "200px" }}>
                      <center>
                        <img
                          src={theme === Mode.Light ? "/images/s5000-logo-small-dark.png" : "/images/s5000-logo-small-light.png"}
                          alt="S5000"
                          width="100%"
                        />
                      </center>
                    </div>
                  </Box>
                  <Box>
                  As Australia’s premier open wheel class, S5000 was an obvious choice for FRG’s suite of ‘Officially’ backed series. This inaugural series will run across the year with races scheduled for Tuesday nights on some of the greatest circuits in the world, many coinciding with real world F1 races at the same venue on the weekend prior in what is recognised as one of iRacing most demanding vehicles.
                  </Box>
                  <PrimaryButton 
                      url="/s5000-series" 
                      buttonName="S5000 Series Info"
                    />
                </SpaceBetween>
              </div>
            </Box>
            <Box padding={"xxl"} >
              <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                maxWidth: "500px",
              }}>
                <SpaceBetween size="xxl">
                  <Box>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "120px", minWidth: "200px" }}>
                      <center>
                        <img
                          src={theme === Mode.Light ? "/images/ffa-logo-small-dark.png" : "/images/ffa-logo-small-light.png"}
                          alt="Formula Ford"
                          width="100%"
                        />
                      </center>
                    </div>
                  </Box>
                  <Box>
                  With the introduction of a current model FF1600 to the iRacing stable, the FORMULA FORD ASSOCIATION | AUSTRALIA and FRG E-SPORTS announced an officially sanctioned AUSTRALIAN FORMULA FORD E-SERIES to the stable. This E-Series has races scheduled from May through to December across many of the circuits in the real world Australian Formula Ford Series.
                  </Box>
                  <PrimaryButton 
                      url="/ffa-series" 
                      buttonName="Formula Ford Series Info" 
                    />
                </SpaceBetween>
              </div>
            </Box>
            {/* <Box padding={"xxl"} >
              <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                maxWidth: "500px",
              }}>
                <SpaceBetween size="xxl">
                  <Box variant="span">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "120px", minWidth: "200px" }}>
                      <img
                        src={theme === Mode.Light ? "/images/apjc/apjc-challenge-logo-dark.png" : "/images/apjc/apjc-challenge-logo-light.png"}
                        alt="Asia-Pacific Junior Esports Challenge"
                        width="100%"
                      />
                    </div>
                  </Box>
                  <Box>
                    The ASIA-PACIFIC JUNIOR ESPORTS CHALLENGE will see the winner of the event attending an Elite International Driver Academy in Sepang, Malaysia in September 2023 as an esport participant. Prize includes return flights for the junior participate and one parent/ guardian#, accommodation, and front row seats to see what it takes to be an elite driver. Valued at approximately $15K AUD
                  </Box>
                  <PrimaryButton 
                      url="/apjc-series" 
                      buttonName="E-Sports Challenge Info" 
                    />
                </SpaceBetween>
              </div>
            </Box> */}
            <Box padding={"xxl"} >
              <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                maxWidth: "500px",
              }}>
                <SpaceBetween size="xxl">
                  <Box variant="div">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minWidth: "200px" }}>
                      <img
                        src={theme === Mode.Light ? "/images/trinations/tri-nations-logo-dark.png" : "/images/trinations/tri-nations-logo-dark.png"}
                        alt="Tri Nations Esports Cup"
                        width="80%"
                      />
                    </div>
                  </Box>
                  <div>
                  Motorsport Australia take on Motorsport UK and Motorsport New Zealand in a virtual battle of the Esports' version of the Ashes. With each of the governing body using a live shootout to select the 10 fastest representatives of each region. Drivers will then compete against each other at two of the world’s most famous circuits, Silverstone & Bathurst  for the ultimate bragging rights.
                  </div>
                  <PrimaryButton 
                      url="/trinations-series" 
                      buttonName="Tri Nations Cup Info" 
                    />
                  </SpaceBetween>
                </div>
              </Box>
            </Grid>
            <Box textAlign="center">
          </Box>
        </Box>
      </SpaceBetween>
    </>    
  );
}
